import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';

import moment from 'moment';
import setting from "../../config/setting";

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});

let id = 0;


class RoutineDescriptionTable extends Component {
    constructor(props) {
        super(props);
        // console.log("received props for list detail");
        // console.log(props);
        this.state = {
            value: "open",
        }
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const classes = this.props;
        const statusSelect = (<Select
            value={this.state.value}
            onChange={this.handleChange}
            inputProps={{
                name: 'value',
                id: 'age-simple',
            }}
        >
            <MenuItem value={"open"}>Open</MenuItem>
            <MenuItem value={"review"}>In Review</MenuItem>
            <MenuItem value={"closed"}>Closed</MenuItem>
            <MenuItem value={"escalated"}>Escalated</MenuItem>
        </Select>)
        return (
            <div className={classes.root}>
                <Toolbar>Alert Information</Toolbar>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell style = {{ whiteSpace: 'nowrap' }} >Status</TableCell>
                            <TableCell style = {{ whiteSpace: 'nowrap' }} >AlertID</TableCell>
                            <TableCell style = {{ whiteSpace: 'nowrap' }} >CreatedBy</TableCell>
                            <TableCell style = {{ whiteSpace: 'nowrap' }} >Date</TableCell>
                            <TableCell style = {{ whiteSpace: 'nowrap' }} >Entity</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableCell>{this.props.metaData.status}</TableCell>
                        <TableCell>{this.props.metaData.alert_ID}</TableCell>
                        <TableCell>{this.props.metaData.owner_name}</TableCell>
                        <TableCell style = {{ whiteSpace: 'nowrap' }} >{this.props.metaData.created_date == "" ? null : moment(this.props.metaData.created_date).format(setting.date_format)}</TableCell>
                        <TableCell style = {{ whiteSpace: 'nowrap' }} >
                            {this.props.metaData.entity}
                        </TableCell>
                    </TableBody>
                </Table>
            </div>
        )
    }
}

RoutineDescriptionTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RoutineDescriptionTable);


// WEBPACK FOOTER //
// ./src/components/Routines/RoutineDescriptionTable.js